<template>
  <div>

    <div
      v-if="service.service_type_name !== 'ADDITIONAL_SERVICES' && service.service_type_name !== 'ATV'"
      class="service-card"
      :class="[serviceStatus, serviceType]"
    >
      <!-- header -->
      <div class="service-card__header">
        <div class="service-card__type">
          {{ service.service_type_value }}
        </div>
        <span class="status-badge" :class="serviceStatus">
          {{ serviceStatusText }}
        </span>
      </div>

      <!-- Tariff info -->
      <div class="service-card__tariff">
        <div class="tariff-name">
          <span v-if="service.tariff && service.tariff.name">{{ service.tariff_legal_title }}</span>
          <span class="tariff-speed" v-if="service.tariff && service.tariff.speed">
          <SpeedIcon/>
           {{ formatSpeedMbps(service.tariff.speed[0].d) }}
          </span>
        </div>
        <div class="tariff-price">
          <span v-if="service.tariff && service.tariff.price">{{ service.tariff.price }} UAH</span>
        </div>
      </div>

      <!-- Info rows -->
      <div class="service-card__info-section">
        <!-- Dates -->
        <div class="info-row">
          <div class="info-label">
            <svg class="info-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
            Термін дії
          </div>
          <div class="info-value">
            <span v-if="serviceDatesBegin || serviceDatesEnd">
              {{ serviceDatesBegin }} <span v-if="serviceDatesBegin && serviceDatesEnd">-</span> {{ serviceDatesEnd }}
            </span>
            <span v-else>Тариф не активний</span>
          </div>
        </div>

        <!-- Balance -->
        <div class="info-row" v-if="service.amount !== undefined && service.amount !== null">
          <div class="info-label">
            <svg class="info-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="12" y1="1" x2="12" y2="23"></line>
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
            </svg>
            Баланс
          </div>
          <div class="info-value info-value--highlight">{{ service.amount }} UAH

          <div v-if="service.deposit" class="deposit-div">
            +100₴ депозиту
          </div>
          </div>

        </div>

        <!-- IP Address -->
        <div class="info-row" v-if="service.ip_address">
          <div class="info-label">
            <svg class="info-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="2" y1="12" x2="22" y2="12"></line>
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
            </svg>
            IP адреса
          </div>
          <div class="info-value">{{ service.ip_address }}</div>
        </div>
      </div>

      <!--  progress bar -->
      <div class="service-card__progress" v-if="service.tariff && !service.tariff.is_unlimited && mbMax">
        <div class="progress-container">
          <div class="progress-bar">
            <div 
              class="progress-fill" 
              :class="{ 'progress-fill--danger': mbCurrent > mbMax }"
              :style="{ width: progressPercentage + '%' }"
            ></div>
          </div>
          <router-link
            class="progress-link"
            :to="{ name: 'traffic', params: { type: service.service_type_name, lsId: lsId } }"
          >
            Використано {{ mbCurrent }}Mb з {{ mbMax }}Mb
          </router-link>
        </div>
      </div>

      <div class="plnd-act" v-if="service.planned_action && service.planned_action.length">
        <h5>
            <svg class="info-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
          Заплановані тарифні зміни</h5>
          <div
            class="plnd-act__item"
            v-for="(action, index) in service.planned_action"
            :key="action.action_id"
          >

            <div class="plnd-act__price">
              {{ action.price }} UAH
            </div>

            <div class="plnd-act__value">
              <div class="plnd-act__title">
                {{ action.value }}
              </div>

              <div
                class="plnd-act__speed"
                v-if="action.speed"
              >
                <SpeedIcon size="18px" />
                {{ formatSpeedMbps(action.speed[0].d) }}
              </div>
            </div>
            <div class="plnd-act__index">
              {{ index + 1 }}
            </div>

          </div>
      </div>
      <div v-if="service.tariff_activation_date">{{ service.tariff_activation_date }}</div>
    </div>
  </div>
</template>

<script>
import fancyProgress from "./fancyProgress.vue";
import SpeedIcon from "./SpeedIcon.vue";

export default {
  props: ["service", "lsId", "multitatiff", "info"],
  components: {
    "e-fancy-progress": fancyProgress,
    SpeedIcon
  },
  data() {
    return {
    };
  },
  methods: {
    formatDateTime(dateStr) {
      const [datePart, timePart] = dateStr.split(' ');
      if (!datePart) return dateStr;

      const [day, month, year] = datePart.split('.');
      const [hours = '00', minutes = '00'] = timePart.split(':') || [];

      const date = new Date(`${year}-${month}-${day}T${hours}:${minutes}:00`);
      if (isNaN(date)) return dateStr;

      const pad = num => num.toString().padStart(2, '0');

      return `${pad(day)}.${pad(month)}.${pad(date.getFullYear() % 100)} ${pad(hours)}:${pad(minutes)}`;
    },
    formatSpeedMbps(value) {
      if (value == null) return '—'

      // >= 1000 Mbps → Gbps
      if (value >= 1000) {
        return `${(value / 1000).toFixed(value % 1000 === 0 ? 0 : 1)} Гбіт/с`
      }

      return `${value} Мбіт/с`
    },
  },
  computed: {
    serviceStatus() {
      switch (this.service.status) {
        case "ACTIVE":
          return "service-card--active";
        case "NOT_ACTIVE":
          return "service-card--disabled";
        default:
          return "service-card--default";
      }
    },
    progressPercentage() {
      if (!this.mbMax || this.mbMax === 0) return 0;
      return Math.min((this.mbCurrent / this.mbMax) * 100, 100);
    },
    mbCurrent() {
      let value = 0;
      if (this.service.tariff["traffic_gb"]) {
        value = Number(this.service.tariff["traffic_gb"]);
      }
      return value;
    },
    mbMax() {
      let limit = 0;
      if (this.service.tariff["traffic_limit"]) {
        limit = Number(this.service.tariff["traffic_limit"]);
      }
      return limit;
    },
    serviceType() {
      switch (this.service.service_type_name) {
        case "ATV":
          return "service-card--atv";
        case "GPON":
          return "service-card--inet";
        case "ETHERNET":
          return "service-card--inet";
      }
    },
    serviceStatusText() {
      let statuses = {
        'ACTIVE': 'Активний',
        'NOT_ACTIVE': 'Неактивний',
        'DISABLED': 'Вiдключений'
      };
      return statuses[this.service.status];
    },
    serviceDatesBegin() {
      if (this.service.tariff?.activated_date) {
        return this.formatDateTime(this.service.tariff.activated_date);
      }
      return '';
    },
    serviceDatesEnd() {
      if (this.service.tariff?.valid_to_date) {
        return this.formatDateTime(this.service.tariff.valid_to_date);
      }
      return '';
    },
  }
};
</script>

<style lang="scss" scoped>
/* Complete Material Design overhaul with white and light blue theme */

.service-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px;
  font-family: 'Roboto', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  transition: box-shadow 0.3s ease, transform 0.2s ease;
  border: 1px solid #0045ff3b;

  /* Header Section */
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 2px solid #E3F2FD;
  }

  &__type {
    font-size: 20px;
    font-weight: 500;
    color: #1976D2;
    letter-spacing: 0.15px;
  }

  .status-badge {
    padding: 6px 16px;
    font-size: 12px;
    font-weight: 500;
    border-radius: 16px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    
    &.service-card--active {
      background-color: #E8F5E9;
      color: #2E7D32;
    }

    &.service-card--disabled {
      background-color: #fbd69c;
      color: #E65100;
    }

    &.service-card--default {
      background-color: #F5F5F5;
      color: #616161;
    }
  }

  /* Tariff Section */
  &__tariff {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    background: linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%);
    border-radius: 8px;
    margin-bottom: 20px;
    font-weight: 600 !important;

    .tariff-name {
      font-size: 16px;
      color: #1565C0;
      display: flex;
      flex-direction: column;
    }

    .tariff-price {
      font-size: 15px;
      font-weight: 500;
      color: #1976D2;
      background: #ffffff;
      padding: 4px 12px;
      border-radius: 23px;
      white-space: nowrap;
      border: 2px solid #80c6ff;
    }

    .tariff-speed {
      color: #1565c0af !important;
      align-self: flex-start;
    }
  }

  /* Info Section */
  &__info-section {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }

  .info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    border-bottom: 1px solid #0400ff33;

    &:last-child {
      border-bottom: none;
    }
  }

  .info-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #555555;
  }

  .info-icon {
    width: 22px;
    height: 22px;
    color: #2196F3;
  }

  .info-value {
    font-size: 16px;
    font-weight: 500;
    color: #212121;
    text-align: right;

    &--highlight {
      color: #1976D2;
      font-weight: 600;
      font-size: 16px;
    }
  }

  /* Progress Section */
  &__progress {
    margin-top: 20px;
  }

  .progress-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .progress-bar {
    width: 100%;
    height: 8px;
    background-color: #E3F2FD;
    border-radius: 4px;
    overflow: hidden;
    position: relative;
  }

  .progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #2196F3 0%, #42A5F5 100%);
    border-radius: 4px;
    transition: width 0.3s ease;

    &--danger {
      background: linear-gradient(90deg, #F44336 0%, #EF5350 100%);
    }
  }

  .progress-link {
    font-size: 13px;
    font-weight: 500;
    color: #1976D2;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: #0D47A1;
      text-decoration: underline;
    }
  }

  /* Responsive Design */
  @media (max-width: 600px) {
    padding: 20px;

    &__header {
      align-items: flex-start;
      gap: 12px;
    }

    &__tariff {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }

    .info-row {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }

    .info-value {
      text-align: left;
    }
  }
}

.plnd-act {
  margin-top: 24px;
  padding: 20px;
  border-top: 2px solid #58b8ff;
  background: aliceblue;
  
  h5 {
    font-size: 16px;
    font-weight: 600;
    color: #1976D2;
    margin: 0 0 16px 0;
    letter-spacing: 0.15px;
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: center;
  }
}

.plnd-act__item {
  background: linear-gradient(135deg, #F5F9FF 0%, #E8F4FD 100%);
  border: 1px solid #BBDEFB;
  border-radius: 8px;
  padding: 14px 16px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(33, 150, 243, 0.08);
  
  &:hover {
    box-shadow: 0 2px 8px rgba(33, 150, 243, 0.15);
    border-color: #90CAF9;
  }
  
  &:last-child {
    margin-bottom: 0;
  }
}

.plnd-act__price {
  font-size: 13px;
  font-weight: 500;
  color: #1976D2;
  background: #ffffff;
  padding: 4px 12px;
  border-radius: 23px;
  white-space: nowrap;
  border: 1px solid #BBDEFB;
}

.plnd-act__value {
  font-size: 15px;
  font-weight: 500;
  color: #1565C0;
  line-height: 1.4;
  min-width: 175px;
  max-width: 175px;
}

.plnd-act__speed {
  color: rgba(21, 101, 192, 0.6862745098) !important;
  align-self: flex-start;
  text-align: left;
}


@media (max-width: 600px) {
  .plnd-act__item {
    display: grid;
    grid-template-areas:
      "value value"
      "price index";
    align-items: center;
    gap: 8px;
  }

  .plnd-act__price {
    grid-area: price;
  }

  .plnd-act__index {
    grid-area: index;
    justify-self: end;
  }

  .plnd-act__value {
    grid-area: value;
  }
  .plnd-act {
    padding: 8px;
  }
}


.plnd-act__index {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #1976d2c4;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.plnd-act__title {
  justify-self: left;
  text-align: left;
}

.deposit-div{
color: green;
  padding: 2px 5px;
  background: #0080001f;
  border: 1px solid #3eb73e66;
  border-radius: 20px;
}
</style>
